<template>
  <a-card :bordered="true" class="dashboard-bar-chart container">
    <router-view></router-view>
  </a-card>
</template>

<script>
export default {
  name: "breed_items",
  components: {
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
  },
}
</script>

<style>
</style>
